
// 时间戳转换日期格式方法  yyyy-MM-dd
export function formatDate(value) {
  if (value == null) {
    return ''
  } else {
    const date = new Date(value)
    const y = date.getFullYear()// 年
    let MM = date.getMonth() + 1 // 月
    MM = MM < 10 ? ('0' + MM) : MM
    let d = date.getDate() // 日
    d = d < 10 ? ('0' + d) : d
    return y + '-' + MM + '-' + d
  }
}

// 时间戳转换日期格式方法 yyyy-MM-dd HH：mm：ss
export function formatDateTime(value) {
  if (value == null) {
    return ''
  } else {
    const date = new Date(value)
    const y = date.getFullYear() // 年
    let MM = date.getMonth() + 1 // 月
    MM = MM < 10 ? ('0' + MM) : MM
    let d = date.getDate() // 日
    d = d < 10 ? ('0' + d) : d
    let h = date.getHours() // 时
    h = h < 10 ? ('0' + h) : h
    let m = date.getMinutes()// 分
    m = m < 10 ? ('0' + m) : m
    let s = date.getSeconds()// 秒
    s = s < 10 ? ('0' + s) : s
    return y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s
  }
}



// WEBPACK FOOTER //
// ./src/utils/dateFormat.js